import React from 'react';
import TestimonialContent from './testimonial-4';
const Four_wraper = () => {
    return (
        <section className="carousel-wrapper tc-four-wrapper bg-primary">
            <TestimonialContent />
        </section>
    )
}
export default Four_wraper;